(function($) {
    $.widget("ca.caDatePicker", {
        options: {
            format : 'm/d/Y',
            showTime : false,
            showAmPm : false,
            width : 80,
            changeable : true,
            onChange : function(date) {},
            showArrows : false
        },
        
        _oldVal: null,
        
        _create : function() {
            var self = this;
            var input = this.element;
            input.wrap('<div class="ca-date-picker-field">');
            $('<a href="#"></a><span class="clear"></span>').insertAfter(input);
            
            if (self.options.showArrows) {
                $('<div class="prev-day"/><div class="next-day"/>').insertBefore(input);
            }
            
            input.width(this.options.width);

            //TODO: need refactoring
            var inputField = this.element;

            inputField.DatePicker({
                format : this.options.format,
                date : inputField.val(),
                current : inputField.val(),
                starts : 0,
                position : 'bottom-right',
                viewTime : this.options.showTime,
                showAmPm : this.options.showAmPm,
                onBeforeShow: function(){
                    if (inputField.val()) {
                        inputField.DatePickerSetDate(inputField.val(), true);
                    }
                },
                onChange: function(formatted, dates){
                    self._oldVal = inputField.val();

                    inputField.val(formatted);
                    inputField.DatePickerHide();
                    inputField.trigger('change');

                    self.options.onChange(formatted, self.element);
                }
            });
            
            if (self.options.showArrows) {
                var dateFormat = self.options.format === 'd/m/Y' ? 'dd/mm/yy' : 'mm/dd/yy';
                this.element.parent().find('.prev-day').on('click', function () {
                    if (self.options.changeable) {
                        var date = new Date(self.getValueInValidFormat());
                        date.setDate(date.getDate() - 1);
                        self.setValue($.datepicker.formatDate(dateFormat, date));
                        self._trigger('daydecreased');
                    }
                });
                this.element.parent().find('.next-day').on('click', function () {
                    if (self.options.changeable) {
                        var date = new Date(self.getValueInValidFormat());
                        date.setDate(date.getDate() + 1);
                        self.setValue($.datepicker.formatDate(dateFormat, date));
                        self._trigger('dayincreased');
                    }
                });
            }
            
            this.setChangeable(this.options.changeable);
        },
        
        getValue: function() {
            return this.element.val();
        },

        getValueInValidFormat: function () {
            var dateString = this.getValue();
            if (this.options.format === 'd/m/Y') {
                dateString = moment(dateString, "DD/MM/YYYY").format('MM/DD/YYYY');
            }
            return dateString;
        },

        getOldValue: function() {
            return this._oldVal;
        },
        
        setValue: function(value) {
            this.element.val(value);
        },
        
        setChangeable: function(changeable) {
            var self = this;
            this.options.changeable = changeable ? true : false;
            if (changeable) {
            this.element.parent().find('a').off('click').click(function() {
                self.element.DatePickerShow();
                return false;
            }).css('cursor', 'pointer');
            this.element.parent().find('.prev-day, .next-day').css('cursor', 'pointer');
            this.element.removeAttr('disabled').parent().removeClass('disabled');            
            } else {
                this.element.parent().find('a').off('click').click(function() {
                    return false;
                }).css('cursor', 'default');
                this.element.parent().find('.prev-day, .next-day').css('cursor', 'default');
                this.element.attr('disabled', true).parent().addClass('disabled');
            }
        },
        
        setOnChange: function(callback) {
            this.options.onChange = callback;
        },

        update: function () {
            this.options.onChange(this.element.val());
        }
    });
})(jQuery);